import React, { useState } from 'react';
import { Resizer } from '@/icons/Resizer';
import { langDirection } from '@/utils/languages';
import { useTranslation } from 'react-i18next';
import styles from './css/TextFeild.module.css';

interface TextFieldProps {
  placeholder: string;
  maxCharacterCount?: number;
  text: string;
  id: string;
  setText: (value: string) => void;
  size?: "xs" | "small" | "large";
  showCharCount?: boolean;
}

const TextField: React.FC<TextFieldProps> = ({ 
  placeholder, 
  text, 
  setText, 
  maxCharacterCount = 150, 
  id, 
  size = "large",
  showCharCount = true,
}) => {
  const [isActive, setIsActive] = useState(false);
  const { i18n } = useTranslation();
  const isRtl = langDirection(i18n.language) === "rtl";

  const borderClass = isActive ? styles.borderActive : styles.borderDefault;
  
  const containerWidthClass = 
    (size === "xs" || size === "small") ? "2xl:w-[690px] w-[700px]" : "w-[820px]";
  
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (event.target.value.length <= maxCharacterCount) {
      setText(event.target.value);
    }
  };
  const handleFocus = () => setIsActive(true);
  const handleBlur = () => setIsActive(false);

  return (
    <div
      className={`
        ${size === "xs" ? styles.containerXs : 
           size === "small" ? styles.containerSmall : 
           styles.containerLarge}
        ${containerWidthClass}
      `}
    >
      <div
        className={`
          ${size === "xs" ? styles.innerWrapperXs : styles.innerWrapperDefault}
          
        `}
      >
        <div
          className={`
            ${size === 'xs' ? styles.borderWrapperXs : styles.borderWrapperDefault}
            ${borderClass}
            ${size === 'small' ? styles.heightSmall : size === 'large' ? styles.heightLarge : ''}
            ${size !== 'xs' ? 'w-full' : ''}
          `}
        >
          <textarea
            placeholder={placeholder}
            className={styles.textareaStyles}
            value={text}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            data-testid={id}
          />
          <div className={isRtl ? styles.resizerRtl : styles.resizerLtr}>
            <Resizer />
          </div>
        </div>
      </div>
      
      {showCharCount && (
        <div
          className={`
          ${size === "xs" ? styles.charCountXs : styles.charCountDefault}
          ${size === "small" ? styles.charCountSmall : ""}
          ${size === "large" ? styles.charCountLarge : ""}
          ${isRtl ? styles.charCountRtl : styles.charCountLtr}
        `}
      >
        {isRtl 
          ? `${maxCharacterCount} / ${text.length}`
            : `${text.length} / ${maxCharacterCount}`}
        </div>
      )}
    </div>
  );
};

export default TextField;